import { memo, useEffect, useRef, useState } from "react"
import { HStack, Input, Center, AspectRatio, Image, Float, Tag, Button } from "@chakra-ui/react"
import { InputGroup } from "@/components/ui/input-group"
import { LuSearch, LuShoppingCart, LuMessageCircle } from "react-icons/lu"
import Slider from "react-slick";
import _ from "lodash";
import { useNavigate } from "react-router"
import ProductList from "@/components/product/list"
const ProductCarousel = ({ data }) => {
    let sliderRef = useRef(null);
    const [products, setProducts] = useState([])
    const navigate = useNavigate();
    useEffect(() => {

        var data2 = _.shuffle(data);
        if(data2.length ==1){
            data2=  [...data2, data2[0]]
        }
        setProducts(data2);

    }, [data])

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        height: 50,
        autoplay: true,
       // lazyLoad: true
      
        // centerMode:true
    };
    return (
       <ProductList data={data}></ProductList>

    )
}

export default memo(ProductCarousel)